<script>
import {mapActions, mapGetters} from 'vuex';
import { uuid } from 'vue-uuid';
import {APP_NAME, APP_VERSION} from "@/utils/constants";
export default {
  name: "common",
  data(){
    return {
      Theme:{
        PINK : '#f29b87',
        GREEN : '#0ba7a3',
        YELLOW : '#FBCB67',
        ORANGE : '#ED8658',
        RED : '#F44336',
        LIGHT_GRAY : '#E0E0E0',
        AFTEE: '#4bdbca',
        PAYPAL: '#0070ba',
        ShippingType: {
          GREEN: '#009944',
          YELLOW: '#FFC10D',
          BLACK: '#000000',
          BLUE: '#547FED'
        },
        ShippingStatus: {
          YELLOW: '#FFC10D',
          GREEN: '#C0E851',
          PURPLE: '#9188F5',
          RED: '#D77575',
          LIGHT_GRAY: '#E6E6E6'
        },
        PaymentType:{
          EPAY:'#588D3F',
          ATM: '#FFC10D',
          AFTEE: '#4bdbca',
          PAYPAL: '#0070ba',
        },
        PaymentStatus:{
          YELLOW: '#FFC10D',
          GREEN: '#C0E851',
          RED: '#D77575',
          LIGHT_GRAY: '#E6E6E6'
        }
      },
      uuid,
      app:{
        APP_NAME,
        APP_VERSION,
      },
      cityData: require("../assets/json/taiwan_city"),
      cityList: [],
      areaList: {},
    }
  },
  created() {

  },
  computed:{
    ...mapGetters(['getUserInfo']),
    isSystem(){
      return this.getUserInfo.role === 1100;
    },
    isAdmin(){
      return this.getUserInfo.role === 1000 || this.isSystem;
    },
    isVendor(){
      return this.getUserInfo.role === 100;
    },
    isStaff(){
      return this.getUserInfo.role === 200 || this.isAccounting;
    },
    isAccounting(){
      return this.getUserInfo.role === 300;
    },
    isSpecialAccount(){
      return this.getUserInfo.email === 'cheesewort@hotmail.com';
    },
    isSpecialAccount2(){
      return this.getUserInfo.level === 'staff';
    },
    isSpecialAccount3(){
      return this.getUserInfo.email === 'smile860617@icloud.com';
    },
    getTicketSortList(){
      return [
        { key :0 , value:'獎籤排法：4列' },
        { key :1 , value:'獎籤排法：5列' },
      ];
    },
    getBannerTypeList(){
      return [
        { key :0 , value:'商品編號' },
        { key :1 , value:'網頁連結' },
        { key :2 , value:'公告編號' },
      ];
    },
    getProductEnable(){
      if (this.isAdmin || this.isStaff){
        return [
          { key :0 , value:'準備中' },
          { key :1 , value:'開抽中' },
          { key :2 , value:'已抽完' },
          // { key :3 , value:'預購中' },
          { key :-1 , value:'已下架' },
        ];
      }
      if (this.getUserInfo.sellStatus === 0){
        return [
          { key :0 , value:'準備中' },
          { key :1 , value:'開抽中' },
          // { key :2 , value:'已抽完' },
          // { key :3 , value:'預購中' },
          // { key :-1 , value:'已下架' },
        ];
      }
      return [
        { key :0 , value:'準備中' },
        // { key :1 , value:'開抽中' },
        // { key :2 , value:'已抽完' },
        // { key :3 , value:'預購中' },
        // { key :-1 , value:'已下架' },
      ];
    },
    getLotteryStyle(){
      return [
        { key :0 , value:'一番賞獎籤(撕籤)' },
        // { key :1 , value:'洞洞樂(戳洞)' },
      ];
    },
    getCategoryList(){
      if (this.isAdmin || this.isStaff){
        return  [{ key: 0 , value: '一番賞'},
          { key: 1 , value: '自製賞'},
          { key: 4 , value: '3C賞'},
          { key: 3 , value: '紅利賞'},
          { key: 5 , value: '刮刮樂'},
          { key: 6 , value: '福利區'},
          { key: 7 , value: '日用品'},
          { key: 2 , value: '盲盒'},
          { key: 8 , value: 'R18'},
          { key: 9 , value: '無限賞'},
          { key: 10 , value: '卡牌'},
          { key: 11 , value: '競標'},
        ];
      }
      return  [{ key: 0 , value: '一番賞'},
        { key: 1 , value: '自製賞'},
        { key: 4 , value: '3C賞'},
        // { key: 3 , value: '紅利賞'},
        { key: 5 , value: '刮刮樂'},
        { key: 7 , value: '日用品'},
        // { key: 2 , value: '盲盒'},
      ];
    },
    getPrizeGroupList(){
      return [
        { key : -1 , value:'無' },
        { key : 0 , value:'1等賞' },
        { key : 1 , value:'2等賞' },
        { key : 2 , value:'3等賞' },
        { key : 3 , value:'4等賞' },
        { key : 4 , value:'5等賞' },
      ];
    },
    isVerifyEmail(){
      return [
        { key : false , value:'未驗證' , color: this.Theme.LIGHT_GRAY },
        { key : true , value:'已驗證' , color: this.Theme.GREEN },
      ];
    },
    getPaymentStatus(){
      return [{key: 0, value: '未付款' , color: this.Theme.PaymentStatus.YELLOW, dark: false },
        {key: 1, value: '已付款' , color: this.Theme.PaymentStatus.GREEN, dark: false },
        {key: 2, value: '退款中' , color: this.Theme.PaymentStatus.RED, dark: true },
        {key: 3, value: '已退款' , color: this.Theme.PaymentStatus.LIGHT_GRAY, dark: false }
      ]
    },
    getShippingType(){
      return [{key: 0, text: '郵局' , color: this.Theme.ShippingType.GREEN, dark: true },
        {key: 1, text: '超商取貨' , color: this.Theme.ShippingType.YELLOW , dark: false},
        {key: 2, text: '黑貓宅配' , color: this.Theme.ShippingType.BLACK, dark: true },
        {key: 3, text: '國際包裹' , color: this.Theme.ShippingType.BLUE, dark: true },
      ]
    },
    getStoreType(){
      return [
        { key: 'UNIMARTC2C' , value: '7-ELEVEN交貨便', color: this.Theme.ShippingType.YELLOW },
        { key: 'FAMIC2C' , value: '全家店到店', color: this.Theme.ShippingType.YELLOW},
        { key: 'HILIFEC2C' , value: '萊爾富店到店', color: this.Theme.ShippingType.YELLOW },
        { key: 'OKMARTC2C' , value: 'OK超商店到店', color: this.Theme.ShippingType.YELLOW },
        { key: 'POST' , value: '宅配-本島運送', color: this.Theme.ShippingType.GREEN },
        { key: 'POST-out' , value: '宅配-離島運送', color: this.Theme.ShippingType.GREEN },
        { key: 'PICKUP' , value: '自取', color: this.Theme.ShippingType.GREEN },
        { key: 'POST-international' , value: '國際配送', color: this.Theme.ShippingType.GREEN }
      ]
    },
    getPaymentType(){
      return [
        {key: 'point', value: '代幣' , color: this.Theme.PaymentType.EPAY, dark: true },
        {key: 'bonus', value: '紅利' , color: this.Theme.PaymentType.ATM, dark: false },
        {key: 'freeTicket' , value: '免運券', color: this.Theme.PaymentType.PAYPAL, dark: true  },
      ]
    },
    getInvoiceType(){
      return [
        {key: 'donate', value: '捐贈發票' , color: this.Theme.ShippingStatus.YELLOW, dark: true },
        {key: 'mobile', value: '手機載具' , color:  this.Theme.ShippingStatus.GREEN, dark: false },
        {key: 'certificate' , value: '自然人憑證載具', color: this.Theme.ShippingStatus.LIGHT_GRAY, dark: true  },
        {key: 'personal' , value: '個人電子發票', color: this.Theme.ShippingStatus.PURPLE, dark: true  },
        {key: 'company' , value: '三聯電子發票', color: this.Theme.ShippingStatus.RED, dark: true  },
      ]
    },
    getCarrierType(){
      return [
        {key: 1, value: '綠界電子發票載具' },
        {key: 2, value: '自然人憑證號碼'  },
        {key: 3, value: '手機條碼載具' },
      ]
    },
    getDonationType(){
      return [
        {key: 0, value: '不捐贈' },
        {key: 1, value: '捐贈'  },
      ]
    },
    getPaymentTypeList(){
      return [
        {key: 'CREDIT', value: '信用卡/超商' , color: this.Theme.ShippingStatus.YELLOW, dark: true },
        {key: 'Credit_CreditCard', value: '信用卡' , color: this.Theme.ShippingStatus.YELLOW, dark: true },
        {key: 'Newebpay', value: '藍新' , color: this.Theme.ShippingStatus.YELLOW, dark: true },
        {key: 'ECPAY', value: '綠界' , color: this.Theme.ShippingStatus.LIGHT_GRAY, dark: true },
        {key: 'JKO', value: '街口' , color: this.Theme.ShippingStatus.RED, dark: true },
        {key: 'ATM', value: '一般ATM轉帳' , color:  this.Theme.ShippingStatus.GREEN, dark: false },
        {key: 'VACC', value: '金流ATM轉帳' , color:  this.Theme.ShippingStatus.GREEN, dark: false },
      ]
    },
    getOrderStatus(){
      return [{key: 0, value: '待出貨' , color: this.Theme.ShippingStatus.YELLOW, dark: false},
        {key: 5, value: '備貨中', color: this.Theme.ShippingStatus.YELLOW, dark: true },
        {key: 1, value: '已出貨' , color: this.Theme.ShippingStatus.GREEN, dark: false },
        {key: 2, value: '已完成' , color: this.Theme.ShippingStatus.LIGHT_GRAY, dark: false },
        {key: 3, value: '已退貨/取消' , color: this.Theme.ShippingStatus.PURPLE, dark: true},
        {key: 4, value: '未取貨', color: this.Theme.ShippingStatus.RED, dark: true },
      ]
    },
    getPrizeStatus(){
      return [{key: 0, value: '未成立' , color: this.Theme.ShippingStatus.YELLOW, dark: false},
        {key: 1, value: '已成立' , color: this.Theme.ShippingStatus.GREEN, dark: false },
      ]
    },
    getCountryType(){
      return [
        { key: 'tw' , text: '台灣' },
        { key: 'hk' , text: '香港' },
        { key: 'mo' , text: '澳門' },
        { key: 'sg' , text: '新加坡' },
        { key: 'my' , text: '馬來西亞' },
        { key: 'vn' , text: '越南' }
      ]
    },
    getGender(){
      return [{key: 0, text: '--' },
        {key: 1, text: '男' },
        {key: 2, text: '女' },
      ]
    },
    getRoleList(){
      return [{key: 0, value: '會員' },
        {key: 100, value: '廠商' },
        {key: 200, value: '員工' },
        {key: 1000, value: '管理者' },
      ]
    },
  },
  methods: {
    ...mapActions([
      'showAlert',
      'hideAlert',
    ]),
    loadCityData(){
      this.cityData.taiwan.forEach((city) => {
        this.cityList.push(city.city);
        this.areaList[city.city] = city.area;
      });
    },
    findStoreType(storeType){
      const find = this.getStoreType.find(s=>s.key === storeType);
      if (find){
        return find.value;
      }
      return '--';
    },
    isDifferenceMoreThanAMonth(date1, date2) {
      // 將日期字符串轉換為日期對象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 計算兩個日期之間的差異（以毫秒為單位）
      const differenceInTime = Math.abs(d2.getTime() - d1.getTime());

      // 計算差異天數
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      // 檢查差異是否超過30天（大致一個月）
      return differenceInDays > 31;
    },
  }
}
</script>

<style scoped>

</style>
